// extracted by mini-css-extract-plugin
export default {"container":"FunctionContainer_container__5gCQJ","container--hidden":"FunctionContainer_container--hidden__AmhUx"};